/**
 * Frosted dark glass for controls that float over media: a translucent grey
 * that blurs and saturates what's behind it, edged with hairline highlights
 * so it holds against both light and dark images. Content on it is white.
 */
export const glassSurfaceClassName =
  "bg-[rgb(82_82_82/0.6)] text-white antialiased backdrop-blur-[8px] backdrop-saturate-150 shadow-[0_-1px_0_0_rgb(255_255_255/0.16),1px_0_0_0_rgb(255_255_255/0.08),-1px_0_0_0_rgb(255_255_255/0.08),0_1px_0_0_rgb(255_255_255/0.16),0_1px_1px_0_rgb(0_0_0/0.16)]";

/** A button on a glass surface: white, with a light wash on hover. */
export const glassButtonClassName =
  "h-6 shrink-0 rounded-full text-white hover:bg-white/15 hover:text-white focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:outline-none";

/**
 * The same glass, denser, for tools that float over text rather than media:
 * the 60% grey reads too light on a white screen for white icons, so this
 * keeps the recipe but darkens the tint to hold contrast on paper.
 */
export const glassSurfaceOverTextClassName = glassSurfaceClassName.replace(
  "bg-[rgb(82_82_82/0.6)]",
  "bg-[rgb(48_48_48/0.84)]",
);

/**
 * Where a floating editor pill (tippy) mounts: the app root, at real size,
 * outside any scaled course tile, or the dialog the editor sits in (a modal
 * makes the rest of the page inert). Not document.body: React only hears
 * events inside its root, so the pill's buttons would go dead there.
 */
export const floatingToolsContainer = (reference: Element): Element =>
  reference.closest('[role="dialog"], [role="alertdialog"]') ??
  document.getElementById("__next") ??
  document.body;

/**
 * Above the course tiles and their ⋯ buttons, below dialogs' overlays
 * (z-[9999] menus and popovers still open over it).
 */
export const FLOATING_TOOLS_Z_INDEX = 800;
